import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card"];
  static values = {
    canBeClosed: { type: Boolean, default: true },
    closeOnBgClick: { type: Boolean, default: true },
    closeOnSubmit: { type: Boolean, default: true },
  };

  connect() {
    this.closeWithKeyboardBound = this.closeWithKeyboard.bind(this);
    this.submitEndBound = this.submitEnd.bind(this);

    document.addEventListener("keydown", this.closeWithKeyboardBound);
    document.addEventListener("turbo:submit-end", this.submitEndBound);
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeWithKeyboardBound);
    document.removeEventListener("turbo:submit-end", this.submitEndBound);
  }

  hideModal() {
    this.element.remove();
  }

  handleBeforeFetchResponse(e) {
    console.log("turbo:before-fetch-response", e.detail.fetchResponse.response.url);
    console.log(e.detail.fetchResponse.response.status);
    if (e.detail.fetchResponse.response.status == 200) {
      this.hideModal();
    }
  }

  submitEnd(e) {
    if (this.closeOnSubmitValue && e.target.id != "filter_form") {
      if (e.detail.success) {
        const contentType = e.detail.fetchResponse.response.headers.get("Content-Type") || "";
        const isTurboStream = contentType.includes("text/vnd.turbo-stream");
        if (!isTurboStream) {
          Turbo.visit(e.detail.fetchResponse.response.url, { action: "replace" });
        }
      }
    }
  }

  closeWithKeyboard(e) {
    if (this.canBeClosedValue) {
      if (e.code == "Escape") {
        this.hideModal();
      }
    }
  }

  closeBackground(e) {
    if (!this.canBeClosedValue || !this.closeOnBgClickValue) return;
    if (!this.hasCardTarget) return;

    // Use the event path so clicks still count as "inside" after pickers re-render
    // their DOM during the same click (contains() fails on detached nodes).
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    if (path.includes(this.cardTarget)) return;

    this.hideModal();
  }
}
